'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroLogo = require('./NitroLogo');

var _NitroLogo2 = _interopRequireDefault(_NitroLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroLogo2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-logo/index.js
// module id = 506
// module chunks = 4